import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AccountSelectionService } from "@front/m19-services";
import { map } from "rxjs";

export const canCreateDspStrategyGuard: CanActivateFn = (_) => {
  const accountSelectionService = inject(AccountSelectionService);
  const router = inject(Router);

  return accountSelectionService.singleAccountMarketplaceSelection$.pipe(
    map((accountMarketplace) => {
      if (
        accountMarketplace.dspAdvertiserId &&
        accountMarketplace.dspAdvertiser?.bidderOrganizationId === accountMarketplace.resourceOrganizationId
      )
        return true;
      else return router.createUrlTree(["/"]);
    }),
  );
};
